// Id gudang induk dari sebuah id: rak → induknya, induk → dirinya sendiri. Dipakai saat yang
// dibutuhkan adalah atribut yang hanya dimiliki induk (mis. koordinat peta), karena rak berada di
// lokasi fisik induknya. `rows` dioper dari luar supaya pemanggil bisa memilih sumbernya sendiri
// (mis. array role-filtered bila ia juga membaca field lain dari baris yang sama).
export const resolveWarehouseParentId = (rows, id) => {
  const source = Array.isArray(rows) ? rows : []

  return source.find((row) => row?.id === id)?.parent_warehouse_id ?? id
}

// Resolusi nama gudang yang rak-aware, untuk tampilan read-only (halaman detail).
// Rak = baris dengan parent_warehouse_id → tampilkan "Induk - Rak", konsisten dengan
// selectedLabel di WarehouseSuggestion. Baris tak ditemukan → '' (perilaku lama dipertahankan).
export const resolveWarehouseName = (rows, id) => {
  const source = Array.isArray(rows) ? rows : []
  const findWarehouse = source.find((row) => row?.id === id)

  if (!findWarehouse) {
    return ''
  }

  if (findWarehouse.parent_warehouse_id != null) {
    const parent = source.find((row) => row?.id === findWarehouse.parent_warehouse_id)

    return parent?.name ? `${parent.name} - ${findWarehouse.name}` : findWarehouse.name
  }

  return findWarehouse.name
}
